export {};
//# sourceMappingURL=IReactNativePluginConfig.js.map